import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { AngularMaterialModule } from '../angular-material.module';

import { ManageInvoiceService } from './manage-invoice.service';
import { ManageInvoiceComponent } from './manage-invoice.component';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    ManageInvoiceService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    ManageInvoiceComponent
  ],
  exports: [
    ManageInvoiceComponent
  ]
})
export class ManageInvoiceModule { }
